import BaseService from "./base-service";
import { City, Province, Country } from "./dto/response/location-response-dto";
import { locationCacheService } from "./location-cache-service";
import axios from "axios";

export class LocationService extends BaseService {
  private resource = "https://btn-des-webapp02.azurewebsites.net/a/multicuenta/api/v1";
  private apiResource = process.env.REACT_APP_BASE_URL ?? "";

  async getCountries(
    onSuccess: (data: Country[]) => void,
    onError: (errorMessage: string) => void
  ) {
    try {
      const { data } = await axios.get(`${this.apiResource}/countries`);
      const countries = data.Data.map((country: any) => ({
        id: country.countryId,
        name: country.name,
        isoCode: country.isoCode
      }));
      onSuccess(countries);
    } catch (error) {
      onError("Error al obtener los países");
    }
  }
  // Usar variable de entorno o URL por defecto si no está configurada
  private locationApiBaseUrl = process.env.REACT_APP_LOCATION_API_URL || "https://btn-des-webapp02.azurewebsites.net/a/multicuenta/api/v1";

  async getProvinces(
    params: undefined,
    onSuccess: (data: Province[]) => void,
    onError: (errorMessage: string) => void
  ) {
    // Verificar caché primero
    const cachedProvinces = locationCacheService.getProvinces();
    if (cachedProvinces) {
      onSuccess(cachedProvinces);
      return;
    }

    try {
      // Usar axios global para tener acceso a los interceptores (token, etc.)
      const { data } = await axios.get(`${this.locationApiBaseUrl}/Province`, {
        headers: {
          'Content-Type': 'application/json',
        }
      });
      
      // La API de location devuelve { data: [...] }
      const provinces = data.data.map((province: any) => ({
        id: province.provincieId,
        name: province.name
      }));
      
      // Guardar en caché
      locationCacheService.setProvinces(provinces);
      onSuccess(provinces);
    } catch (error: any) {
      console.error("Error al obtener provincias:", error);
      onError(error.response?.data?.message || error.message || "Error al obtener las provincias");
    }
  }

  async getCitiesByProvince(
    provinceId: number,
    onSuccess: (data: City[]) => void,
    onError: (errorMessage: string) => void
  ) {
    // Verificar caché primero
    const cachedCities = locationCacheService.getCities(provinceId);
    if (cachedCities) {
      onSuccess(cachedCities);
      return;
    }

    try {
      // Usar axios global para tener acceso a los interceptores (token, etc.)
      const { data } = await axios.get(`${this.locationApiBaseUrl}/City`, {
        params: { provinceId },
        headers: {
          'Content-Type': 'application/json',
        }
      });
      
      // La API de location devuelve { data: [...] }
      const cities = data.data.map((city: any) => ({
        id: city.cityId,
        name: city.name
      }));
      
      // Guardar en caché
      locationCacheService.setCities(provinceId, cities);
      onSuccess(cities);
    } catch (error: any) {
      console.error("Error al obtener ciudades:", error);
      onError(error.response?.data?.message || error.message || "Error al obtener las ciudades");
    }
  }
}
